import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAC } from '../selectors/AC'
import { USER_ROLES } from '../../modules/ac/constants'
import { hasPermissionKey } from '../../modules/ac/permissionKeys'
import useUserRole from './useUserRole'

const usePermission = (serviceName, actionName) => {
  const userRole = useUserRole()
  const { permissionKeys } = useSelector(selectAC)

  return useMemo(
    () => userRole === USER_ROLES.SUPER_ADMIN
      || hasPermissionKey(permissionKeys, serviceName, actionName),
    [userRole, permissionKeys, serviceName, actionName]
  )
}

export default usePermission
